module.exports = __webpack_public_path__ + "img/Vector-Stadium-PNG-Clipart.498695c5.png";